<template>
    <div>
        <v-card>
            <v-card-title>
                <span class="text-h5">Solicitud: {{ reference }}</span>
            </v-card-title>
            <v-card-text>
                <v-container fluid>
                    <v-row>
                        <!-- <v-col cols="6" sm="6" md="6" class="pb-0">
                            <v-autocomplete
                            v-model="employee"
                            :items="itemsEmployees"
                            label="Empleado"
                            outlined
                            auto-select-first
                            :disabled="disableRef"
                            ></v-autocomplete>
                        </v-col> -->
                        <v-col cols="6" sm="6" md="6" class="pb-0">
                            <v-autocomplete
                                v-model="selectedKit"
                                :items="itemsKits"
                                label="Set Personalizado"
                                auto-select-first
                                outlined
                                ref="cod"
                            ></v-autocomplete>
                        </v-col>
                        <v-col cols="2" sm="2" md="2">
                            <v-icon
                                color="success"
                                @click="onList"
                                v-text="'mdi-check-outline'"
                                :disabled="!isNewItemOk"
                            ></v-icon> - 
                            <v-icon v-if="disableRef"
                                color="warning"
                                @click="onEdit"
                                v-text="'mdi-circle-edit-outline'"
                            ></v-icon>
                        </v-col>
                    </v-row>
                    
                    <v-data-table
                        :headers="headers"
                        :items="productsAggregate"
                        
                        class="elevation-1 custom-font"
                    >
                    <template v-slot:[`item.actions`]="{ item }">
                        <v-icon small @click="deleteItem(item)">
                            mdi-delete
                        </v-icon>
                    </template>
                    </v-data-table>
                </v-container>
            </v-card-text>
            <v-card-actions>
                <v-alert shaped dense dark type="info" v-if="info !== ''">
                    {{ info }}
                </v-alert>
                <v-spacer></v-spacer>
                <v-btn color="blue darken-1" text @click="cancelStock">
                    Cancelar
                </v-btn>
                <v-btn :disabled="!isOk" color="blue darken-1" text @click="saveStock">
                    solicitar
                </v-btn>
            </v-card-actions>
        </v-card>
    </div>
</template>
<script>
import { getEmployees, getProducts, getKits, getKitById, saveRequest, getKitsByEmployee, getFilteredEmployees } from '../dataApi'
import UserProfile from "../data";
export default {
    name: 'requestKits',
    data: () => ({
        user: UserProfile.getUserData(),
        selectedRef: null,
        selectedKit: null,
        product: 0,
        quantity: 0,
        employee: null,
        reference: `Set-${Date.now().toString().slice(-6)}`,
        itemsProducts: [],
        itemsEmployees: [],
        employees: [],
        allEmployees: [],
        itemsKits: [],
        allKits: [],
        productsAggregate:[],
        disableRef: false,
        originLabel: null,
        headers: [
            { text: 'Empleado', value: 'employee' },
            { text: 'Cantidad', value: 'quantity' },
            { text: 'Producto', value: 'category' },
            { text: 'Observacion', value: 'note' },
            { text: "Acciones", value: "actions", sortable: false },
        ],
        info: "",
    }),

    methods: {
        async createdValuesItems(){
            const { employees, employeesItems } = await getEmployees();
            const { products, productsItems } = await getProducts();
            const { kitsItems, allKits } = await getKits();
            this.itemsKits = kitsItems;
            this.allKits = allKits;
            this.allEmployees = employees;
            this.products = products;
            this.itemsEmployees = employeesItems;
            this.itemsProducts = productsItems;
        },

        async onList(){
            const kit = await getKitById(this.selectedKit)
            kit.items.forEach(async item => {
                const employeesFiltered = await getFilteredEmployees({
                    position: item.position,
                    costCenter: kit.costCenter,
                    gender: item.sex
                })
                employeesFiltered.forEach(employee => {
                    const exist = this.productsAggregate.findIndex(product => product.employeeId === employee.value && product.categoryId === item.category.id)
                    if(exist !== -1) {
                        this.productsAggregate[exist].quantity += item.quantity;
                    } else {
                        this.productsAggregate.push({
                            categoryId: item.category.id,
                            category: item.category.name,
                            quantity: item.quantity,
                            employeeId: employee.value,
                            employee: employee.text,
                            note: "automatizado",
                        })
                    }
                })

            })
            
            // const employee = this.itemsEmployees.find(employee => employee.value === this.employee)
            // const employee = this.itemsEmployees.find(employee => employee.value === this.employee)
            // console.log(employee, kit)
            // kit.items.forEach(item => {
            //     const exist = this.productsAggregate.findIndex(product => product.productId === item?.product?.id && product.employeeId === this.employee)    
            //     if(exist !== -1) {
            //         this.productsAggregate[exist].quantity += item.quantity;
            //     } else {
            //         this.productsAggregate.push({
            //             productId: item?.product?.id,
            //             product: item?.product?.description,
            //             quantity: item.quantity,
            //             employeeId: this.employee,
            //             employee: employee.text,
            //             note: "automatizado",
            //         });
            //     }
            // })
        },

        async onCalculate(){
            const quantity = parseInt(this.quantity)
            const product = this.itemsProducts.find(product => product.value === this.product)
            const employee = this.itemsEmployees.find(employee => employee.value === this.employee)
            const exist = this.productsAggregate.findIndex(product => product.productId === this.product && product.employeeId === this.employee)
            if(exist !== -1) {
                this.productsAggregate[exist].quantity += quantity;
            } else {
                this.productsAggregate.push({
                    productId: this.product,
                    product: product.text,
                    quantity,
                    employeeId: this.employee,
                    employee: employee.text,
                    note: this.reference,
                });
            }
            this.quantity = 0;
            this.product = 0;
            this.disableRef = true;
            if(!this.originLabel) {
                const origin = this.itemsProviders.find(provider => provider.value === this.provider)
                if(origin) this.originLabel = origin.text
            }
        },
        deleteItem(item){
            const index = this.productsAggregate.findIndex(product => product.id === item.id)
            if (index !== -1) {
                this.productsAggregate.splice(index, 1);
            }
        },
        onEdit(){
            this.disableRef = false;
            this.originLabel = null;
        },
        cancelStock(){
            this.$emit("closeModal")
        },
        async saveStock(){
            const stock = {
                items: [],
                ref: this.reference
            }
            this.productsAggregate.forEach(product => {
                stock.items.push({
                    categoryId: product.categoryId,
                    quantity: product.quantity,
                    finalEmployeeId: product.employeeId,
                })
            })
            console.log("stock", stock)
            await saveRequest(stock)
            console.log("stock guardado")
            this.cancelStock()
        }
    },

    mounted() {
        this.createdValuesItems();
    },

    computed: {
        isNewItemOk(){
            return this.selectedKit
        },
        isOk(){
            return this.productsAggregate.length > 0;
        },
        async calculatedEmployee(){
            const employees = []
            if(!this.selectedKit) return employees
            
        }
    },

    watch: {
        // async selectedKit(newValue, value){
        //     if(newValue === value || newValue === null) return
        //     const employees = []
        //     const kit = this.allKits.find(kit => kit.id === newValue)
        //     for await (const item of kit.items) {
        //         console.log("buscamos", item.costCenter, item.position)
        //         employees.push(...await getFilteredEmployees({
        //             position: item.position,
        //             costCenter: item.costCenter
        //         }))
        //     }
        //     this.itemsEmployees = employees;
        // }
        async employee(newValue, value){
            if(newValue === value || newValue === null) return
            const emp = this.allEmployees.find(employee => employee.id === newValue)
            this.itemsKits = await getKitsByEmployee(emp);
        }
    }
}
</script>